export const BASE_URL = process.env.REACT_APP_API_URL;
export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const passwordPattern = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;

export const BACKENDS = {
    stage: 'https://api.stage.dataryx.ai',
    live: 'https://api.dataryx.ai',
    local: 'http://localhost:8000',
};

export const getCurrentBackendUrl = (): string => {
    const backendKey = localStorage.getItem('selectedBackend') || 'live';
    return BACKENDS[backendKey as keyof typeof BACKENDS];
};

export const setCurrentBackend = (backendKey: string): void => {
    localStorage.setItem('selectedBackend', backendKey);
    localStorage.setItem('lastUsedBackend', backendKey);
};
